import { Col } from '@/components/Col';
import { Grid } from '@/components/Grid';
import { Typography } from '@/components/Typography';
import type { AddressFragment } from '@/graphql/saleor/api';
import { ACCOUNT_METADATA } from '@/lib/metadata/const';
import { getMetaValue } from '@/lib/metadata/helpers';

import { formatAddress } from '../MyAddresses/AddressSummary';

type AddressSectionProps = {
  address: AddressFragment;
  heading?: JSX.Element;
  honorificPrefix?: string | null;
  showName?: boolean;
};

export const AddressSection = ({
  address,
  heading,
  honorificPrefix,
  showName = true,
}: AddressSectionProps) => {
  const companyName = address.companyName;
  const vat = getMetaValue(address.metadata ?? [], ACCOUNT_METADATA.vatNumber);
  const displayVat = address?.country?.code === 'GB' && vat;
  const displayAbn = address?.country?.code === 'AU' && vat;

  return (
    <Grid data-test-id='AddressSectionGrid'>
      {heading && (
        <Col data-test-id='AddressSectionCol-heading' xs={12}>
          {heading}
        </Col>
      )}
      {showName && (
        <Col data-test-id='AddressSectionCol-name'>
          <Typography data-test-id='AddressSectionTypography-name'>
            {honorificPrefix} {address?.firstName} {address?.lastName}
          </Typography>
        </Col>
      )}
      {companyName && (
        <Col data-testid='AddressSectionCol-companyName'>
          <Typography>{companyName}</Typography>
        </Col>
      )}
      {displayVat && (
        <Col data-testid='AddressSectionCol-vat'>
          <Typography>VAT: {vat}</Typography>
        </Col>
      )}
      {displayAbn && (
        <Col data-testid='AddressSectionCol-abn'>
          <Typography>ABN: {vat}</Typography>
        </Col>
      )}
      <Col data-test-id='AddressSectionCol-address'>
        <Typography data-test-id='AddressSectionTypography-address'>
          {formatAddress(address, address?.country?.code)}
        </Typography>
      </Col>
    </Grid>
  );
};
